import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '@/shared/auth/useAuth';
import { Alert } from '@/shared/ui/Alert';

import { quando, useMaintenanceStatus } from './useMaintenanceStatus';

/**
 * Avisos de manutencao na moldura da aplicacao.
 *
 * Dois avisos diferentes, de donos diferentes. O aviso da empresa e escrito por
 * quem administra a empresa, na aba Acesso das configuracoes. A janela da plataforma
 * e da administracao da plataforma: agendada, vira aviso; em andamento, leva a tela
 * de manutencao.
 *
 * Quem administra a plataforma continua trabalhando durante a janela: e quem vai
 * encerra-la. Esconder a tela dos demais e orientacao; a janela existe para avisar,
 * e o servidor nao recusa requisicao por causa dela.
 */
export function MaintenanceNotices() {
  const { session } = useAuth();
  const location = useLocation();
  const { data: situacao } = useMaintenanceStatus();

  if (situacao?.under_maintenance && !session?.platform_admin) {
    return <Navigate to="/manutencao" replace state={{ from: location.pathname }} />;
  }

  const avisoDaEmpresa = session?.tenant.access?.maintenance_warning ?? '';
  const proxima = situacao?.next ?? null;
  const emAndamento = situacao?.under_maintenance ? situacao.current : null;

  if (!avisoDaEmpresa && !proxima && !emAndamento) return null;

  return (
    <div className="mb-5 flex flex-col gap-3">
      {emAndamento ? (
        <Alert tone="warning" title="Plataforma em manutencao">
          {emAndamento.message} As demais pessoas estao vendo a tela de manutencao.
        </Alert>
      ) : null}
      {avisoDaEmpresa ? (
        <Alert tone="warning" title="Aviso de manutencao">
          {avisoDaEmpresa}
        </Alert>
      ) : null}
      {proxima ? (
        <Alert tone="info" title="Manutencao programada">
          {proxima.message} Inicio em {quando(proxima.starts_at)}
          {proxima.ends_at ? `, retorno previsto em ${quando(proxima.ends_at)}` : ''}.
        </Alert>
      ) : null}
    </div>
  );
}
